import h from 'hyperscript';

import { Modal } from 'ui/dialog/modal/modal';
import type { Select } from 'ui/select/select';
import { HelpTopicLink } from 'ui/help-topic-link/help-topic-link';

import i18n from './animation-settings-dialog.properties';
import './animation-settings-dialog.css';

const COMPONENT_NAME = 'd-animation-settings-dialog';

// obsolete when workbook/view.js is translated to TypeScript
export interface View {
  id: string;
  text: string;
}

export interface AnimationSettingResult {
  type: string;
  viewId?: string;
  unit?: string;
  timeWindow?: number;
  overlap?: number;
  rangeStart: string | number;
  rangeEnd: string | number;
  sliderRangeStart: Date | unknown;
  sliderRangeEnd: Date | unknown;
}

export abstract class AnimationSettingsDialog extends Modal<AnimationSettingResult> {

  #initialized = false;
  #viewSelect?: Select;

  protected constructor () {
    super({ title: i18n('animation.settings.title') });
  }

  override connectedCallback () {
    super.connectedCallback();
    this.#initialize();
  }

  get selectedViewId () {
    return this.#viewSelect?.selection[0].id;
  }

  async #initialize () {
    if (!this.#initialized) {
      this.classList.add(COMPONENT_NAME);
      await this._renderContent();
      this.#initialized = true;
    }
  }

  abstract createSpecificContent (): HTMLElement[];

  async _renderContent () {
    this.body.append(h('.d-animation-settings-dialog--body', [
      h('.d-animation-settings-dialog--content', [
        null,
        ...this.createSpecificContent()
      ])
    ]));
    this.addSubmitButton(i18n('animation.settings.generate.animation'));
    this.addCancelButton();
    this._addDocumentationLink();
  }

  _addDocumentationLink () {
    const documentationLink = new HelpTopicLink();
    documentationLink.dataset.topicId = 'animation-settings';
    documentationLink.textContent = i18n('animation.settings.documentation');
    documentationLink.classList.add('d-animation-settings-dialog--doc-link');
    this.footer.append(documentationLink);
  }

}

